import { Link as RouterLink }                              from 'react-router-dom'
import BaseTable, { BaseSearch }                           from '../ui/components/base-table'
import { Box, Button, Container, Link, Stack, Typography } from '@mui/material'
import Page                                                from '../ui/components/Page'
import Iconify                                             from '../ui/components/Iconify'
import { useTranslation }                                  from 'react-i18next'
import React, { useContext, useState }                     from 'react'
import { useApi }                                          from '../utils/api'
import { BaseBreadcrumbs }                                 from '../ui/components/BaseBreadcrumbs'
import { AppContext }                                      from '../App'

export default function PartnersPage() {

  const api = useApi()
  const { user } = useContext(AppContext)
  const { t } = useTranslation()
  const [query, setQuery] = useState('')

  const columns = [
    { field: 'id', headerName: t('ID'), width: 100, sortable: false, filterable: false },
    { field: 'name', headerName: t('Name'), flex: 2, sortable: false, filterable: false, renderCell: (cell) => {
        return (
          <Link
            component={RouterLink}
            variant="body2"
            to={`/partners/${cell.row.id}`}
          >
            {cell.row.name}
          </Link>
        )
      }},
  ];

  return (<Page title={t('Partners')}>
    <Container>
      <BaseBreadcrumbs key={'breadcrumb-partners'}
                       title={t('Partners')}
                       items={[]} />
      <Stack direction="row" alignItems="center" mb={5} spacing={2}>
        <Typography variant="h4" gutterBottom>{t('Partners')}</Typography>
        <BaseSearch query={query} onQueryChanged={(query) => setQuery(query)} />
        <Box flexGrow={'1'} />
        <Button variant="contained"
                component={RouterLink}
                to="/partners/create"
                startIcon={<Iconify icon="material-symbols:add" />}
                disabled={user?.readonly}>
          {t('New partner')}
        </Button>
      </Stack>
      <BaseTable
        columns={columns}
        query={query}
        loadCallback={async (query, page, pageSize) => {
          try {
            return await api.partner.list(query, page, pageSize)
          } catch (e) {
            console.log('Failed to load partners', e)
            return {
              data: [],
              totalCount: 0,
            }
          }
        }}
      />
    </Container>
  </Page>)

}